import beneficiaryService from 'Services/BeneficiaryService'

// initial state
const state = {
  beneficiaries: []
}

// getters
const getters = {
  beneficiary: state => id => state.beneficiaries.find(beneficiary => beneficiary.beneficiaryId === id) || {}
}

const actions = {
  filterBeneficiaries: ({ commit }, { context, filterContext }) => {
    const { request, cancelToken } = beneficiaryService.getAll(context, filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then((result) => {
        commit('setBeneficiaries', result.data)
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getBeneficiaries: ({ dispatch }, { context }) => {
    return dispatch('filterBeneficiaries', { context }).then(({ promise }) => promise.then(result => result.data))
  },

  getBeneficiary: ({ commit }, { context, beneficiaryId }) => {
    return new Promise((resolve, reject) => {
      beneficiaryService.get(context, beneficiaryId).then(result => {
        commit(state.beneficiaries.some(item => item.beneficiaryId === result.beneficiaryId) ? 'updateBeneficiary' : 'setBeneficiary', result)
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateBeneficiaryStatus: ({ dispatch }, { context, beneficiaryId, status }) => {
    return new Promise((resolve, reject) => {
      beneficiaryService.updateStatus(context, beneficiaryId, { status }).then(() => {
        return dispatch('getBeneficiary', { context, beneficiaryId }).then(result => resolve(result))
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setBeneficiaries (state, beneficiaries) {
    state.beneficiaries = beneficiaries
  },

  setBeneficiary (state, beneficiary) {
    state.beneficiaries.push(beneficiary)
  },

  updateBeneficiary (state, beneficiary) {
    state.beneficiaries = state.beneficiaries.map(item =>
      item.beneficiaryId === beneficiary.beneficiaryId ? beneficiary : item
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
